export class Pageable <T=any>{
  content: Array<T>;
  first: boolean;
  last: boolean;
  number: number = 0;
  numberOfElements: number = 0;
  pageable: any;
  size: number = 0;
  sort: any;
  totalElements: number = 0;
  totalPages: number = 0;
}
